import { Checkbox } from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { type Company, type UserPayload } from 'src/utils/type';

export default function DepartmentSelect ({
  isMobile,
  selectedCompany,
  user,
  handleDepartmentChange,
}: {
  isMobile: boolean;
  selectedCompany: Company;
  user: UserPayload;
  handleDepartmentChange: (_, checked: boolean) => void;
}) {
  const { t } = useTranslation();
  return (
    <>
      {selectedCompany && (
        <Box display="flex" alignItems="flex-start" marginBottom={isMobile ? '24px' : '0px'}>
          <label>
            {t('Department')}<sup>*</sup>:
          </label>
          <Box display="flex" flex="1" flexWrap="wrap" flexDirection={isMobile ? 'column' : 'row'}>
            {selectedCompany.departments.map(department => (
              <Box key={department} display="flex" alignItems="center" marginBottom={isMobile ? '6px' : '24px'}>
                <Checkbox
                  checked={user.department.includes(department)}
                  onChange={(_, checked) => { handleDepartmentChange(department, checked); }}
                />
                <span className="checkbox-label">{department}</span>
              </Box>
            ))}
          </Box>
        </Box>
      )}
    </>
  );
}
